import { moveToFulfilled, moveToPending, moveToRejected, remove } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { DeleteGroupFulfilledAction } from '../../domains/groupDeletion/actions.types';
import { GroupSidebarLoadAction } from '../../domains/groupSidebarLoad/actions.types';
import { Group } from '../types';

import { GroupSidebars } from './types';

export type GroupSidebarAction = GroupSidebarLoadAction | DeleteGroupFulfilledAction;

const initialState: GroupSidebars = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

type StateWithFulfilledGroupSidebar = (state: GroupSidebars, id: Group['id']) => GroupSidebars;
const stateWithFulfilledGroupSidebar: StateWithFulfilledGroupSidebar = (state, id) =>
  moveToFulfilled(state, { [id]: { id } });

const reducer: Reducer<GroupSidebars, GroupSidebarAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'GROUP_SIDEBAR.LOAD_PENDING':
      return moveToPending(state, [action.payload.id]);
    case 'GROUP_SIDEBAR.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.id], action.payload.error);
    case 'GROUP_SIDEBAR.LOAD_FULFILLED':
      return stateWithFulfilledGroupSidebar(state, action.payload.id);
    case 'GROUP.DELETE_FULFILLED':
      return remove(state, [action.payload.groupId]);
    default:
      return state;
  }
};

export default reducer;
